enum Reason {
  CUSTOMER = "customer",
  INVENTORY = "inventory",
  FRAUD = "fraud",
  OTHER = "other",
  TEST = "test",
}

export default Reason;
